import { ColumnDef } from "@tanstack/react-table";
import { TruncatedText } from "components/shared/truncated-text";

export interface UsageRow {
  id: string;
  keyName: string;
  addresses: number;
  buildings: number;
  batches: number;
  maps: number;
  landparcels: number;
  predictive: number;
  esri: number;
  clip: number;
  adminbounds: number;
}

export const cols: ColumnDef<UsageRow>[] = [
  {
    id: "keyName",
    accessorKey: "keyName",
    header: "API Key",
    size: 200,
    cell: ({ getValue }) => (
      <TruncatedText className="max-w-full">
        {getValue() as string}
      </TruncatedText>
    ),
  },
  {
    id: "addresses",
    accessorKey: "addresses",
    header: "Addresses API",
  },
  {
    id: "buildings",
    accessorKey: "buildings",
    header: "Buildings API",
  },
  { id: "batches", accessorKey: "batches", header: "Batches API" },
  { id: "maps", accessorKey: "maps", header: "Maps API" },
  {
    id: "landparcels",
    accessorKey: "landparcels",
    header: "Land Parcels API",
  },
  {
    id: "predictive",
    accessorKey: "predictive",
    header: "Predictive API",
  },
  {
    id: "esri",
    accessorKey: "esri",
    header: "Esri Locator API",
  },
  { id: "clip", accessorKey: "clip", header: "Clip" },
  {
    id: "adminbounds",
    accessorKey: "adminbounds",
    header: "Admin Boundaries API",
  },
];
